<template>
  <VToolbar
    :class="isDemo ? 'header--demo' : 'header--customer'"
    class="header"
    flat
    data-testid="desktop-header"
  >
    <!-- A page can replace the promo with its own bar content, as nuxt2's slot
         did: the proxy-order checkout's Back. -->
    <VContainer :fluid="!!$slots.default" class="pa-0 px-2">
      <VRow no-gutters align="center" :justify="$slots.default ? 'start' : 'center'">
        <slot>
          <LayoutHeaderPromo />
        </slot>
      </VRow>
    </VContainer>
  </VToolbar>
</template>

<script lang="ts" setup>

interface Props {
 isDemo?: boolean
}

withDefaults(defineProps<Props>(), {
  isDemo: false,
})
</script>

<style lang='scss' scoped>
  .header--customer {
    background-image: linear-gradient(to right, #009A9B, #00B3A8);
  }
  .header--demo {
    background-image: linear-gradient(to right, #223E6D, #0D5893);
  }
  .header {
    z-index: 12;
    flex-grow: 0;
    // Auto height (not a fixed 20px) so the bar grows to fit a rendered promo
    // banner; min-height keeps it at 20px when there's no promo. AB#59248
    height: auto;
    min-height: 20px;
    :deep(.v-toolbar__content) {
        padding: 8px 0;
        // Vuetify 3's VToolbar sets the content height as an INLINE style
        // (`height: 64px`, the default toolbar height). Inline styles outrank
        // any stylesheet rule regardless of cascade layer, so `!important` is
        // the only thing that overrides it back to auto. Without it the bar is
        // stuck at 64px (AB#60936 follow-up). min-height has no inline rival,
        // so it doesn't need it.
        height: auto !important;
        min-height: 20px;
    }
  }
</style>
